import * as React from 'react'
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl'
import GenericPage from '../../sections/generic-page'
import Seo from '../../components/seo'

const GDPR = () => {
  return (
    <>
      <Seo
        description="Integritetspolicy"
        image="https://www.dooer.com/images/og/og_index.jpg"
        title="Integritetspolicy | Dooer"
        url="https://www.dooer.com/gdpr"
      />

      <GenericPage
        ledeText={
          <FormattedMessage
            defaultMessage="Vi samlar bara in det som vi verkligen behöver för att du ska få en så bra och smidig upplevelse av Dooer som möjligt. Inga konstigheter, precis som det ska vara."
            id="gdpr.lede"
          />
        }
        titleText={
          <FormattedMessage defaultMessage="Dina personuppgifter är trygga med oss på Dooer." id="gdpr.title" />
        }
      >
        <FormattedHTMLMessage
          defaultMessage={`
      <h1>Integritetspolicy</h1>
      <h2>GENERELLT</h2>
      <p>
        Dooer Sverige AB samlar in och använder dina personuppgifter för att
        fullgöra, förbättra och anpassa våra åtaganden, produkter och
        tjänster.
      </p>
      <p>
        Vi använder också informationen i marknadsföringssyfte för att
        informera dig om våra produkter och tjänster samt att ge dig
        uppdaterade guider / utbildning inom vårt verksamhetsområde.
      </p>
      <p>
        Du kan närsomhelst be oss rätta dina uppgifter, be oss exportera dem,
        be oss ta bort dig helt från våra databaser eller skicka in klagomål
        till Datainspektionen gällande Dooer Sverige AB:s hantering av dina
        personuppgifter.
      </p>
      <p>
        Dooer Sverige AB samlar in personuppgifter med stöd av följande
        rättsliga grunder:
      </p>
      <ol>
        <li>Samtycke</li>
        <li>Fullgörande av avtal</li>
      </ol>
      <p>
        Samtycke används bland annat men inte uteslutande för behandling av
        personuppgifter kopplat till nyhetsbrev och intresseanmälan.
      </p>
      <p>
        Fullgörande av avtal stödjer vår personuppgiftsbehandling som är
        kopplad till tjänst/tjänsterna där du som Kund har ingått avtal med
        att få en sådan tjänst levererad.
      </p>
      <h2>HUR LÄNGE LAGRAR VI DIN PERSONUPPGIFTSDATA?</h2>
      <p>
        Dooer Sverige AB lagrar din data så länge det krävs att tillhandahålla
        tjänsten/tjänsterna eller för att uppfylla det ändamål i vilket data
        samlades in.
      </p>
      <h2>PERSONUPPGIFTSDATA HOS TREDJE PART</h2>
      <p>
        För att fullfölja ingångna avtal med dig som Kund så kan vi komma att
        lämna ut din data till tredje part. Att fullfölja ingångna avtal med
        dig som kund kan innebära ändamål som att tillhandahålla tjänsten /
        tjänsterna, marknadsföra tjänsten / tjänsterna men är inte begränsat
        till det.
      </p>
      <p>
        Data som lämnas ut till tredje part får dock endast användas på ett
        sätt som beskrivs i avtal som tredje part ingått med Dooer Sverige AB
        eller annat företag i Dooer AB koncernen.
      </p>
      <p>
        Tredje part kan återfinnas inom EU/ESS och utanför detta
        samarbetsområde. Om tredje part återfinns utanför EU/ESS så vidtas
        särskilda skyddsåtgärder vid hantering av din data.
      </p>
      <h2>INTEGRATIONER AKTIVERADE AV DIG SOM KUND</h2>
      <p>
        Dooer Sverige AB tillhandahåller integrationspunkter med olika
        samarbetspartners för att förbättra upplevelsen tjänsten/tjänsterna.
      </p>
      <p>Dessa integrationspunkter aktiverar du själv som Kund.</p>
      <p>
        För att tillhandahålla dessa integrationer så kan data som kan anses
        vara privat och känslig delas med dessa samarbetsparter. Det framgår
        dock vid aktiverandet vilken data vi delar med oss av.
      </p>
      <h2>ÖVRIG TILLGÅNG TILL DIN PERSONUPPGIFTSDATA</h2>
      <p>
        Myndighetskrav och lagar kan innebära att Dooer Sverige AB måste lämna
        ut din data.
      </p>
      <p>
        Slutligen så kommer Dooer Sverige AB lämna ut din data, till dig eller
        tredje part om det sker på begäran från dig som Kund.
      </p>
      <h2>SKYDD AV DATA</h2>
      <p>
        Dooer Sverige AB hanterar all data med etablerade säkerhetsstandarder
        och rutiner för att skydda den mot obehörig åtkomst, ändring,
        spridning och förstörelse.
      </p>
      <h2>COOKIES</h2>
      <p>
        En cookie är information som en webbplats lagrar på en besökares dator
        och att besökarens webbläsare ger till webbplatsen varje gång
        besökaren återkommer till webbplatsen. Dooer Sverige AB använder
        cookies för att identifiera och spåra besökare, deras användning av
        Dooers Sverige AB hemsida och deras inställningar. Dooer besökare som
        inte vill att cookies placeras på sin dator bör ställa in sina
        webbläsare att vägra cookies innan de använder Dooers Sverige AB
        webbplatser, med nackdelen att vissa funktioner på Dooers Sverige AB
        webbplatser kanske inte fungerar korrekt med denna inställning.
      </p>
      <h2>KONTAKT OCH PERSONUPPGIFTSANSVARIG</h2>
      <p>
        Dooer Sverige AB (559056-7508) är personuppgiftsansvarig. Dooer
        Sverige AB bestämmer för vilka ändamål uppgifterna ska behandlas och
        hur behandlingen ska gå till. För frågor gällande vår datahantering,
        vänligen kontakta support@dooer.com
      </p>
      <h2>ÄNDRINGAR OCH TILLÄGG TILL INTEGRITETSPOLICYN</h2>
      <p>
        Denna integritetspolicy kan komma att ändras i framtiden om exempelvis
        förändringar eller lagändringar sker. Vi rekommenderar därför att du
        regelbundet läser våra villkor för att kunna hålla dig uppdaterad och
        ta del av den senaste versionen.
      </p>
      `}
          id="gdpr.policy"
        />
      </GenericPage>
    </>
  )
}

export default GDPR
